<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="isLoading"
  >
    <b-container class="d-flex justify-content-center align-items-center min-vh-100">
      <b-card
        class="text-center shadow-lg payment-card"
        style="max-width: 600px; width: 100%;"
      >
        <feather-icon
          size="64"
          class="text-success mb-2 animate__animated animate__bounceIn"
          :icon="getIcon(receiptPayment)"
        />

        <h2 class="text-success mb-1">
          {{ getStatusName(receiptPayment) }}
        </h2>
        <div class="text-left ml-1">
          <p><strong>Mã giao dịch:</strong> {{ receiptPayment.merchantOrderId }}</p>
          <p><strong>Tổng tiền:</strong> {{ showCurrencyVND(receiptPayment.amount) }}</p>
          <p><strong>Nội dung:</strong> {{ receiptPayment.description }}</p>
          <p><strong>Thời gian:</strong> {{ getFormattedDate(receiptPayment.payDate) }}</p>
        </div>

        <b-button
          variant="primary"
          @click="$router.replace({ name: 'portalDashboard' })"
        >
          <feather-icon icon="ArrowLeftIcon" /> Quay về trang chủ
        </b-button>
      </b-card>
    </b-container>
  </b-overlay>
</template>

<script>
import {
  BContainer, BCard, BButton, BOverlay,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import api from './api'

export default {
  components: {
    BOverlay,
    BContainer,
    BCard,
    BButton,
    FeatherIcon,
  },
  data() {
    return {
      isLoading: false,
      receiptPayment: {
        merchantOrderId: null,
        description: null,
        amount: null,
        payDate: null,
        responseDescription: null,
        errorDetail: null,
        status: null,
      },
    }
  },
  async created() {
    this.isLoading = true
    try {
      this.receiptPayment = await api.getPaymentByReturnUrl({
        merchantOrderId: this.$route.query.data,
        responseCode: this.$route.query.vnptpayResponseCode,
        secureCode: this.$route.query.secureCode,
      })
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    showCurrencyVND(value) {
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      })
      return formatter.format(value)
    },

    getFormattedDate(dateString) {
      return dateString ? moment(dateString, 'YYYYMMDDHHmmss').format('DD/MM/YYYY HH:mm:ss') : ''
    },
    getIcon(data) {
      return data && data.status === 0 ? 'CheckCircleIcon' : 'XCircleIcon'
    },
    getStatusName(data) {
      return data && data.status === 0 ? data.responseDescription : data.errorDetail
    },
  },
}
</script>

<style scoped>
.payment-card {
  border-radius: 10px;
  padding: 2rem;
}
@media (max-width: 576px) {
  .payment-card {
    padding: 1rem;
  }
  .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
</style>
